module.exports = __webpack_public_path__ + "img/warning.adaf241c.svg";